import { render, staticRenderFns } from "./PCOrderDetail.vue?vue&type=template&id=62385ac6&scoped=true"
import script from "./PCOrderDetail.vue?vue&type=script&lang=js"
export * from "./PCOrderDetail.vue?vue&type=script&lang=js"
import style0 from "./PCOrderDetail.vue?vue&type=style&index=0&id=62385ac6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62385ac6",
  null
  
)

export default component.exports